import {gsap, ScrollTrigger} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class BlockStorytellingImage {
	static init() {

		this.block = document.querySelector('.block-storytelling-image');

		if (!this.block) {
			return;
		}
		if (ScrollTrigger.isTouch !== 1) {
			if (typeof GlobalVariables.smoother !== "undefined") {
				GlobalVariables.smoother.paused(true);
			}
			this.animation(this.block);
		}
	}

	static animation(block) {
		const canvas = block.querySelector("#canvasStorytelling");
		const context = canvas.getContext("2d");

		canvas.width = "1920";
		canvas.height = "1080";

		const frameCount = 1180;
		const currentFrame = (index) => mcArgs.themeLink + `/frames-storytelling-2/${(index + 1).toString().padStart(4, "0")}.jpg`;

		const animation = {
			frame: 20
		};
		const length = "+=40000";

		const loaderContainer = document.querySelector('#storytelling-loader');
		const loaderBar = loaderContainer.querySelector('.loader-bar');

		let imagesLoaded = 0;
		const images = [];
		const imagePromises = [];

		function updateLoaderProgress() {
			const progress = Math.round((imagesLoaded / frameCount) * 100);
			loaderBar.style.width = `${progress}%`;
		}

		function loadImage(src) {
			return new Promise((resolve, reject) => {
				const img = new Image();
				img.onload = () => {
					imagesLoaded++;
					updateLoaderProgress();
					resolve(img);
				};
				img.onerror = reject;
				img.src = src;
				if (img.complete) {
					imagesLoaded++;
					updateLoaderProgress();
					resolve(img);
				}
			});
		}

		for (let i = animation.frame; i < frameCount; i++) {
			const src = currentFrame(i);
			imagePromises.push(loadImage(src));
		}

		Promise.all(imagePromises)
			.then(loadedImages => {
				images.push(...loadedImages);
				startAnimation();
			})
			.catch(error => {
				console.error("Erreur lors du chargement des images:", error);
			});

		let tlText; // Déclaration de la variable tlText

		function startAnimation() {
			loaderContainer.classList.add("loaded");
			if (typeof GlobalVariables.smoother !== "undefined") {
				GlobalVariables.smoother.paused(false);
			}

			ScrollTrigger.create({
				trigger: block,
				start: "center center",
				end: "+=35000",
				pin: true
			});

			// Animation du texte au scroll
			const text1 = block.querySelector('.text-1');
			const text2 = block.querySelector('.text-2');
			const text3 = block.querySelector('.text-3');
			const text4 = block.querySelector('.text-4');
			const text5 = block.querySelector('.text-5');
			const text6 = block.querySelector('.text-6');

			gsap.set(text1, {autoAlpha: 0, y: "20%"});
			gsap.set(text2, {autoAlpha: 0, y: "-30%"});
			gsap.set(text3, {autoAlpha: 0, y: "-30%"});
			gsap.set(text4, {autoAlpha: 0, y: "-20%"});
			gsap.set(text5, {autoAlpha: 0, y: "-20%"});
			gsap.set(text6, {autoAlpha: 0, y: "-30%"});

			tlText = gsap.timeline({
				scrollTrigger: {
					trigger: block,
					invalidateOnRefresh: true,
					start: "top bottom",
					end: length,
					scrub: true
				},
				ease: "none"
			});

			tlText
				.addLabel("start")

				.to(text1, {autoAlpha: 1, y: 0, duration: 1}, "start")
				.to(text1, {autoAlpha: 0, y: "-100%", duration: 1}, "start+=4")

				.to(text2, {autoAlpha: 1, y: "-50%", duration: 1}, "start+=19")
				.to(text2, {autoAlpha: 0, y: "-70%", duration: 1}, "start+=25")

				.to(text3, {autoAlpha: 1, y: "-50%", duration: 1}, "start+=31")
				.to(text3, {autoAlpha: 0, y: "-70%", duration: 1}, "start+=38")

				.to(text4, {autoAlpha: 1, y: 0, duration: 1}, "start+=48")
				.to(text4, {autoAlpha: 0, y: "20%", duration: 1}, "start+=54")

				.to(text5, {autoAlpha: 1, y: 0, duration: 1}, "start+=57")
				.to(text5, {autoAlpha: 0, y: "-20%", duration: 1}, "start+=63")

				.to(text6, {autoAlpha: 1, y: "-50%", duration: 1}, "start+=79")
				.to(text6, {autoAlpha: 0, y: "-70%", duration: 1}, "start+=84")

				.to(text1, {autoAlpha: 0, y: 0, duration: 0}, "start+=96");

			gsap.to(animation, {
				frame: frameCount - 1,
				snap: "frame",
				ease: "none",
				scrollTrigger: {
					trigger: ".canvas-container",
					start: "top bottom",
					end: length,
					scrub: true
				},
				onUpdate: render
			});

			render(); // Afficher la première image
		}

		function render() {
			if (images[animation.frame]) {
				context.clearRect(0, 0, canvas.width, canvas.height);
				context.drawImage(images[animation.frame], 0, 0, canvas.width, canvas.height);
			}
		}
	}
}
